export function mapBetslipStateToProps(state) {
    return {
        ...state,
        betslip: state.betslip,
    };
}
